const MAP_OPTIONS_DESKTOP = {
  zoomControlOptions: {
    position: "$ControlPosition.RIGHT_TOP"
  },
  streetViewControlOptions: {
    position: "$ControlPosition.RIGHT_TOP"
  },
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: true,
  zoomControl: true
}

const MAP_OPTIONS_MOBILE = {
  ...MAP_OPTIONS_DESKTOP,
  streetViewControlOptions: false,
  zoomControlOptions: undefined,
  zoomControl: false,
  streetViewControl: false
}

export { MAP_OPTIONS_DESKTOP, MAP_OPTIONS_MOBILE }
